import React, {FC} from 'react'
import {PageTitle} from '../../../../_metronic/layout/core'
import {useIntl} from 'react-intl'
import IssueAreasCard from './components/IssueAreasCard'
import {useAbility} from '@casl/react'
import {AbilityContext} from '../../../modules/auth/core/AbilityContext'
import NoPermissionCard from '../../../../_metronic/layout/components/permission/NoPermissionCard'

const IssueAreasLayout: FC<{subject: string}> = ({subject}) => {
  const intl = useIntl()
  const ability = useAbility(AbilityContext)
  // return ability.can('read', subject) ? (
  return (
    <>
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: subject})}</PageTitle>
      <IssueAreasCard />
    </>
  )
  // ) : (
  //   <NoPermissionCard />
  // )
}

export default IssueAreasLayout
